import React, { Component } from "react";
import PropTypes from "prop-types";
import { Row, Col, FormGroup, Modal, Button, FormControl, ControlLabel, Checkbox, ProgressBar } from "react-bootstrap";
import Select from "react-select";
import LoaderInline from "../helpers/LoaderInline";
import InlineError from "../messages/InlineError";
import { getMinutes } from "../helpers/HelperFunctions";

class EditLoggedHoursModal extends Component {

	submit = (e) => {
		e.preventDefault();
		this.props.onUpdateSubmit();
	}

	delete = (e) => { this.props.logToDelete(); }

	renderTaskProgress = () => {
		let styleClass = "warning";
		const { status, progress } = this.props;
		if (status && progress && progress >= 0) {
			styleClass = "info";
			if (progress > 100) {
				styleClass = "danger";
			}
			else if (status == 3 && progress <= 100) {  // eslint-disable-line
				styleClass = "success";
			}
			return <ProgressBar bsStyle={styleClass} now={progress > 100 ? 100 : progress} label={`${progress}%`} />;
		}
		return <h6><i>Progress is not available</i></h6>;
	}

	render() {
		const minutes = getMinutes(60);
		const taskProgress = this.renderTaskProgress();
		return (
			<React.Fragment>
				<Modal bsSize="lg" className="log-hours-modal" show={this.props.showEditModal}>
					<form onSubmit={this.submit}>
						<Modal.Header>
							<button type="button" className="close btn-close-modal" aria-hidden="true" onClick={this.props.closeEditModal}>&times;</button>
							<Modal.Title>{this.props.selectedTask && this.props.selectedTask.label}</Modal.Title>
						</Modal.Header>

						<Modal.Body>
							<Row>
								{this.props.directTask &&
									<Col md={12}>
										<FormGroup>
											<Checkbox name="directTask" inline onChange={() => null} checked={this.props.directTask} disabled>
												Direct Task
											</Checkbox>
										</FormGroup>
									</Col>
								}
							</Row>
							<Row>
								<Col md={12}>
									<FormGroup>
										<ControlLabel>Project:</ControlLabel>
										<FormControl type="string" name="project_name" placeholder="Enter task name" value={this.props.projectName} onChange={() => null} disabled />
									</FormGroup>
								</Col>
							</Row>
							<Row>
								{!this.props.directTask &&
									<Col md={12}>
										<FormGroup  >
											<ControlLabel>Task:</ControlLabel>
											<Select
												onChange={(option) => null}
												name="task_id"
												placeholder="Choose Task"
												value={this.props.selectedTask}
												options={null}
												clearable={false}
												multi={false}
												disabled
											/>
										</FormGroup>
									</Col>
								}
							</Row>
							<Row>
								<Col md={4} sm={4} xs={6}>
									<FormGroup validationState={this.props.errors.time && "error"}>
										<ControlLabel>Hours:</ControlLabel>
										<FormControl type="number" name="time" placeholder="Enter hours" value={this.props.hours || 0} onChange={this.props.onChangeHours} />
										{this.props.errors.time && <InlineError text={this.props.errors.time} />}
									</FormGroup>
								</Col>
								<Col md={4} sm={4} xs={6}>
									<FormGroup validationState={this.props.errors.time && "error"}>
										<ControlLabel>Minutes:</ControlLabel>
										<Select
											onChange={(option) => { this.props.onMinutesSelectChange(option); }}
											name="minutes"
											placeholder="Enter Minutes"
											value={this.props.minutes}
											options={minutes}
											clearable
											multi={false}
										/>
									</FormGroup>
								</Col>
								<Col md={4} sm={4} xs={12}>
									<FormGroup validationState={this.props.errors.log_type_id && "error"}>
										<ControlLabel>Log type:</ControlLabel>
										<Select
											onChange={(option) => { this.props.onSelectChange(option, "log_type_id", "selectedLogType"); }}
											name="log_type_id"
											placeholder="Choose log type"
											value={this.props.selectedLogType}
											options={this.props.logTypes}
											clearable={false}
											multi={false}
										/>
										{this.props.errors.log_type_id && <InlineError text={this.props.errors.log_type_id} />}
									</FormGroup>
								</Col>
							</Row>
							{/* direct task log hours inputs */}
							{this.props.directTask &&
								<Row>
									<Col md={4} sm={4} xs={12}>
										<FormGroup>
											<ControlLabel>Project:</ControlLabel>
											<Select
												onChange={() => null}
												name="project_id"
												placeholder="Choose parent project"
												value={this.props.selectedProject}
												options={[]}
												disabled
												multi={false}
											/>
										</FormGroup>
									</Col>
									<Col md={4} sm={4} xs={12}>
										<FormGroup>
											<ControlLabel>Area:</ControlLabel>
											<Select
												onChange={() => null}
												name="area_id"
												placeholder="Choose project area"
												value={this.props.selectedArea}
												options={[]}
												disabled
												multi={false}
											/>
										</FormGroup>
									</Col>
									<Col md={4} sm={4} xs={12}>
										<FormGroup validationState={this.props.errors.name && "error"}>
											<ControlLabel>Task name:</ControlLabel>
											<FormControl type="string" name="name" placeholder="Enter task name" value={this.props.formData.name || ""} onChange={this.props.onChange} />
											{this.props.errors.name && <InlineError text={this.props.errors.name} />}
										</FormGroup>
									</Col>
								</Row>
							}
							{/* end of direct task inputs  */}
							<Row>
								<Col md={12}>
									<FormGroup validationState={this.props.errors.description && "error"}>
										<ControlLabel>Area description</ControlLabel>
										<FormControl componentClass="textarea" name="description" value={this.props.formData.description || ""} onChange={this.props.onChange} />
										{this.props.errors.description && <InlineError text={this.props.errors.description} />}
									</FormGroup>
								</Col>
							</Row>
							<Row>
								<Col md={12}>
									<h5>Task progress:</h5>
									{taskProgress}
								</Col>
							</Row>
						</Modal.Body>

						<Modal.Footer>
							{this.props.showDeleteBtn ?
								<Button title="Delete" bsStyle="default" onClick={() => this.delete()} className="btn-action material-icons btn-delete pull-left">delete</Button>
								: null
							}
							<Button bsStyle="primary" className="btn-min" type={"submit"} disabled={this.props.isEditingHours}>
								{this.props.isEditingHours ? <LoaderInline width="20" height="20" color="#fff" /> : "Update"}
							</Button>

							<Button bsStyle="default" className="btn-min" onClick={this.props.closeEditModal}>Close</Button>
						</Modal.Footer>
					</form>
				</Modal>
			</React.Fragment >
		);
	}
}

EditLoggedHoursModal.defaultProps = {
	progress: null,
	projectName: PropTypes.string,
	status: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]),
	selectedTask: PropTypes.object,
	selectedLogType: PropTypes.object,
	selectedProject: PropTypes.object,
	selectedArea: PropTypes.object,
	showDeleteBtn: PropTypes.bool,
	errors: PropTypes.object,
	minutes: PropTypes.number,
	hours: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]),
};

EditLoggedHoursModal.propTypes = {
	showEditModal: PropTypes.bool.isRequired,
	isEditingHours: PropTypes.bool.isRequired,
	directTask: PropTypes.bool.isRequired,
	showDeleteBtn: PropTypes.bool,
	projectName: PropTypes.string.isRequired,
	progress: PropTypes.number,
	status: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]),
	hours: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]),
	formData: PropTypes.shape({
		time: PropTypes.string,
		name: PropTypes.string,
		description: PropTypes.string
	}).isRequired,
	errors: PropTypes.shape({
		description: PropTypes.string,
		task_id: PropTypes.string,
		time: PropTypes.string,
		log_type_id: PropTypes.string,
		name: PropTypes.string
	}),
	logTypes: PropTypes.arrayOf(
		PropTypes.object
	).isRequired,
	selectedTask: PropTypes.shape({
		label: PropTypes.string,
		value: PropTypes.number
	}),
	selectedProject: PropTypes.shape({
		label: PropTypes.string,
		value: PropTypes.number
	}),
	selectedArea: PropTypes.shape({
		label: PropTypes.string,
		value: PropTypes.number
	}),
	selectedLogType: PropTypes.shape({
		label: PropTypes.string,
		value: PropTypes.number
	}),
	minutes: PropTypes.shape({
		label: PropTypes.string,
		value: PropTypes.number
	}),
	onUpdateSubmit: PropTypes.func.isRequired,
	onChange: PropTypes.func.isRequired,
	onChangeHours: PropTypes.func.isRequired,
	logToDelete: PropTypes.func.isRequired,
	closeEditModal: PropTypes.func.isRequired,
	onMinutesSelectChange: PropTypes.func.isRequired,
	onSelectChange: PropTypes.func.isRequired,
};

export default EditLoggedHoursModal;



// WEBPACK FOOTER //
// ./src/components/modals/EditLoggedHoursModal.js